// import {Dimensions, StyleSheet} from 'react-native';
import {Dimensions, Platform, StyleSheet} from 'react-native';

import {cloudLight} from '/theme/color/on.color';

const {width, height} = Dimensions.get('window');
const isLandscape = width > height;

export const styles = StyleSheet.create({
  backdrop: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0,0,0,0.45)',
  },
  modalRoot: {flex: 1, backgroundColor: 'rgba(0,0,0,0.45)'},

  keyboardSpacer: {
    flex: 1,
    justifyContent: Platform.OS === 'web' ? 'flex-start' : 'flex-end',
    alignItems: Platform.OS === 'web' ? 'flex-end' : 'stretch',
  },

  sheetCard: {
    width: Platform.OS === 'web' ? 480 : '100%',
    height: Platform.OS === 'web' ? '100%' : undefined,
    alignSelf: Platform.OS === 'web' ? 'flex-end' : undefined,
    backgroundColor: '#FFFFFF',
    borderTopLeftRadius: Platform.OS === 'web' ? 24 : 24,
    borderTopRightRadius: Platform.OS === 'web' ? 0 : 24,
    borderBottomLeftRadius: Platform.OS === 'web' ? 24 : 0,
    borderBottomRightRadius: 0,
    overflow: 'hidden',
    shadowColor: '#000',
    shadowOffset: {
      width: Platform.OS === 'web' ? -4 : 0,
      height: Platform.OS === 'web' ? 0 : -4,
    },
    shadowOpacity: 0.1,
    shadowRadius: 12,
    elevation: 20,
  },

  headerRow: {
    flexDirection: 'row',
    alignItems: 'center',
    paddingHorizontal: 6,
    paddingVertical: 5,
  },

  closeButton: {
    width: 48,
    height: 48,
    justifyContent: 'center',
    alignItems: 'center',
    flexShrink: 0,
  },

  closeIcon: {
    fontSize: 22,
    color: '#667085',
  },

  headingText: {
    fontSize: 16,
    fontWeight: '800',
    color: '#344054',
  },

  divider: {
    height: 1,
    backgroundColor: '#F2F4F7',
  },

  body: {
    paddingHorizontal: 20,
    flexGrow: 0,
  },

  bodyContent: {
    paddingTop: 16,
    // paddingBottom: 20,
    paddingBottom: 10,
  },

  clearButtonText: {
    fontSize: 13,
    fontWeight: '500',
    color: '#344054',
  },

  saveButtonDisabled: {
    backgroundColor: '#E4E7EC',
  },

  saveButtonText: {
    fontSize: 16,
    fontWeight: '600',
    color: '#FFF',
  },

  saveButtonTextDisabled: {
    color: '#667085',
  },
  footer: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    paddingHorizontal: 20,
    paddingTop: 30,
    borderTopWidth: 1,
    borderTopColor: cloudLight,
    backgroundColor: '#FFF',
  },

  footerFullWidth: {
    justifyContent: 'center',
  },
  clearButton: {
    height: 48,
    paddingHorizontal: 20,
    borderRadius: 12,
    borderWidth: 1,
    borderColor: '#D0D5DD',
    justifyContent: 'center',
    backgroundColor: '#FFF',
    minWidth: 110,
  },

  saveButton: {
    height: 48,
    minWidth: 110,
    borderRadius: 12,
    backgroundColor: '#2C2C2C',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    paddingHorizontal: 20,
  },

  saveButtonFullWidth: {
    width: isLandscape ? '86%' : '98%',
    minWidth: 0,
    height: 52,
  },
});
